/**
 * user-api-serverless wrappers for the persona-based "follow celeb" feature.
 *
 * All requests go through the BFF proxy at /proxy/user, where HMAC signing
 * happens server-side. Calls act AS the current DM persona (the follower is the
 * persona's JWT user_id). Intended for the TEST environment.
 *
 * Endpoints:
 *   - GET    /api/v0/partner/celeb/search       directory (+ is_following, reverse is_fan)
 *   - POST   /api/v0/celeb/follow/by/{user_id}  follow
 *   - DELETE /api/v0/celeb/follow/by/{user_id}  unfollow
 */

import { dmRequest } from './dmApiClient';

export const USER_PROXY = '/proxy/user';

/**
 * Search Partner Celebs (is_celeb=2). Empty query → fan_count DESC directory.
 * NOTE: this endpoint returns items/total at the TOP level (no `data` wrapper).
 */
export async function searchPartnerCelebs({ query = '', page = 0, size = 20 } = {}, accessToken) {
  const res = await dmRequest(USER_PROXY, '/api/v0/partner/celeb/search', {
    method: 'GET',
    query: { query: query || undefined, page, size },
    accessToken,
  });
  const d = res || {};
  return {
    items: Array.isArray(d.items) ? d.items : [],
    page: Number(d.page ?? page),
    size: Number(d.size ?? size),
    total: Number(d.total ?? 0),
    totalPages: Number(d.total_pages ?? 0),
  };
}

export async function followCeleb(userId, accessToken) {
  const res = await dmRequest(USER_PROXY, `/api/v0/celeb/follow/by/${userId}`, {
    method: 'POST',
    body: {},
    accessToken,
  });
  return res?.data ?? null;
}

export async function unfollowCeleb(userId, accessToken) {
  const res = await dmRequest(USER_PROXY, `/api/v0/celeb/follow/by/${userId}`, {
    method: 'DELETE',
    accessToken,
  });
  return res?.data ?? null;
}
